import React from 'react';

import {CallsListSection} from './components/CallsListSection';
import {EvaluationItem} from './components/EvaluationItem';
import {EVALUATION_OP_NAME} from './constants';
import {
  calculateCallMetrics,
  calculateLatency,
  toOptionalMetric,
} from './utils';

interface RecentEvaluationsProps {
  entityName: string;
  projectName: string;
}

export const RecentEvaluations: React.FC<RecentEvaluationsProps> = ({
  entityName,
  projectName,
}) => {
  return (
    <CallsListSection
      entityName={entityName}
      projectName={projectName}
      title="Recent evaluations"
      viewAllPath="evaluations"
      filter={{
        opVersionRefs: [
          `weave:///${entityName}/${projectName}/op/${EVALUATION_OP_NAME}:*`,
        ],
      }}
      renderItem={call => {
        const {totalTokens, totalCost} = calculateCallMetrics(call);
        const latency = calculateLatency(
          call.traceCall?.started_at,
          call.traceCall?.ended_at
        );

        return (
          <EvaluationItem
            key={call.callId}
            name={call.spanName}
            callId={call.callId}
            displayName={call.displayName ?? undefined}
            calledAt={call.traceCall.started_at}
            latency={latency}
            tokens={toOptionalMetric(totalTokens)}
            cost={toOptionalMetric(totalCost)}
            userId={call.userId ?? undefined}
            entityName={entityName}
            projectName={projectName}
          />
        );
      }}
      emptyMessage="No evaluations yet"
      emptySubtitle="Evaluations you run will appear here"
      emptyIcon="benchmark-square"
      emptyIconColor="text-gold-500"
      emptyIconBgGradient="from-gold-50 to-gold-100"
    />
  );
};
